import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSun = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 4
		}),
		/* @__PURE__ */ _jsx("path", { d: "M12 2.5V5M12 19v2.5M5.28 5.28 7.05 7.05M16.95 16.95l1.77 1.77M2.5 12H5M19 12h2.5M5.28 18.72 7.05 16.95M16.95 7.05l1.77-1.77" })
	]
});
const ForwardRef = forwardRef(SvgSun);
export default ForwardRef;
